import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { Box } from 'grid-styled';
import { FormattedMessage, FormattedHTMLMessage, injectIntl } from 'react-intl';
import {
  ROUTE_ANALYSE_INFO,
  ROUTE_ANALYSE_SELECT,
  ROUTE_ANALYSE_VIDEO
} from 'RouteList';
import styled from 'styled-components';
import YoutubeEmbedVideo from 'youtube-embed-video';
import { withLastLocation } from 'react-router-last-location';

import Button from 'components/Button/Button';
import { paragraphStyle, H2Style } from 'components/P/textStyle';

import messages from './messages';
import { ANALYSE_BUILDING_BLOCKS } from '../../constants';
import { Query } from 'react-apollo';
import { QUERY_GET_ANALYSE } from '../../services/graphql/video-analyse-query';
import P from '../../components/P/P';

const HTMLWrapper = styled.div`
  padding-left: 20px;
  padding-right: 20px;

  h2 {
    ${H2Style};
    color: ${props => props.theme.colors.primary};
    margin-top: 1rem;
    margin-bottom: 1.5rem;
    line-height: 1.1;
  }

  p {
    ${paragraphStyle};
    font-family: ${props => props.theme.fonts.fontfaceBeta};
    line-height: 1.35;
    color: ${props => props.theme.colors.black};
    font-size: ${props => props.theme.fonts.sizeBase};
    margin-bottom: 1.25rem;
    max-width: 55rem;
  }
`;

const findItemById = (list, id) => {
  let result = null;
  list.forEach(data => {
    data.data.forEach(items => {
      const buildingBlock = items.items.find(item => item.id === id);
      if (buildingBlock) {
        result = buildingBlock;
      }
    });
  });
  return result;
};

@inject('routing', 'uiState')
@injectIntl
@observer
export default class InfoPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  gotoVideoPage() {
    const {
      videoAnalyseId,
      analyseId,
      routing: { push },
      lastLocation
    } = this.props;
    push(`${ROUTE_ANALYSE_VIDEO}/${videoAnalyseId}/${analyseId}`);
  }

  goBack = () => {
    const { routing: { push }, analyseId, videoAnalyseId } = this.props;
    push(`${ROUTE_ANALYSE_SELECT}/${videoAnalyseId}/${analyseId}`);
  };

  render() {
    const { analyseId, intl, lastLocation } = this.props;
    return (
      <Query
        query={QUERY_GET_ANALYSE}
        variables={{ analyseId }}
        fetchPolicy={'cache-and-network'}
      >
        {({ loading, error, data }) => {
          if (loading) return <P>Bezig met laden...</P>;
          if (error) return <P danger>{error.message}</P>;
          const analyse = data.getAnalyse;
          if (!analyse) {
            return (
              <P danger>{intl.formatMessage(messages.analiseErrorLoading)}</P>
            );
          }
          return (
            <HTMLWrapper>
              {analyse.buildingBlocks.map(bb => (
                <Fragment key={bb}>
                  <h2>
                    {findItemById(
                      ANALYSE_BUILDING_BLOCKS,
                      bb
                    ).label.toUpperCase()}
                  </h2>
                  <div style={{ marginBottom: 30 }}>
                    <YoutubeEmbedVideo
                      size="medium"
                      suggestions={false}
                      showInfo={false}
                      videoId={intl.formatMessage(
                        messages['analyseInfoVideo' + bb]
                      )}
                    />
                  </div>
                  <FormattedHTMLMessage
                    {...messages['analyseInfoBlock' + bb]}
                  />
                </Fragment>
              ))}
              <Box width={1 / 1} mt={2}>
                <Button
                  primary
                  disabled={data.loading}
                  onClick={() => {
                    this.goBack();
                  }}
                  style={{ marginRight: 8 }}
                >
                  <FormattedMessage {...messages.analyseInfoBackButton} />
                </Button>
                {analyse.buildingBlocks.length > 0 && (
                  <Button
                    primary
                    onClick={() => {
                      this.gotoVideoPage();
                    }}
                  >
                    <FormattedMessage {...messages.analyseInfoButton} />
                  </Button>
                )}
              </Box>
            </HTMLWrapper>
          );
        }}
      </Query>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/analyse/InfoPage.js